<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>people</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.users' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>

        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->

        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="search page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->
      <div>
        <button mat-raised-button
          [routerLink]="'/pages/user/new'"
          class="add-product-button mat-white-bg my-12 mt-sm-0">
          <span>{{'user.add_new_user' | translate}}</span>
        </button>

        <mat-button-toggle-group #group="matButtonToggleGroup" class="communication-action"
          [disabled]="!checkedUsers.length" (change)="communicationAction($event)">
          <mat-button-toggle value="mail" [disabled]="!checkedUsers.length" matTooltip="MAIL">
            <mat-icon>email</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>

        <button mat-button class="mat-icon-button sidenav-toggle ml-12 mat-icon-button-custom"
          fuseMatSidenavToggler="user-main-sidenav"
          fxHide.gt-lg>
          <mat-icon>filter_list</mat-icon>
        </button>
      </div>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <mat-sidenav-container class="my-sidenav"
      [style.display]="sidenav.opened ? 'block' : 'none'">
      <mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"
        fuseMatSidenavHelper="user-main-sidenav" mat-is-locked-open="gt-sm" [ngClass]="{'hide-menu': !sidenav.opened}">
        <div class="sidenav-toggle-div">
          <button mat-button class="mat-icon-button sidenav-toggle ml-12"
            fuseMatSidenavToggler="user-main-sidenav"
            fxHide.gt-lg>
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <filter-menu [filters]="filterData" [page]="'admin'" [filterFromDB]="userFilters"
        (chooseFilter)="chooseFilters($event)"></filter-menu>
      </mat-sidenav>
    </mat-sidenav-container>

    <div class="content-card mat-white-bg"
      [ngClass]="{'margin-big-screen': sidenav.opened}">

      <mat-table class="products-table"
        #table [dataSource]="users"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar
        (scroll)="onScroll($event)"
        id="adminUserPage"
        (matSortChange)="sortData($event)">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="checkBoxWidthClass">
            <mat-checkbox (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="checkBoxWidthClass">
            <mat-checkbox (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null; checkUser(row, $event)"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="logo">
          <mat-header-cell class="hide-on-mobile"  *cdkHeaderCellDef></mat-header-cell>
          <mat-cell *cdkCellDef="let user" class="hide-on-mobile">
            @if (user.logo) {
              <img class="user-photo"
                [src]="getImage(user.logo)"/>
            }
            @if (!user.logo) {
              <img class="product-image" [src]="'assets/images/user_black.svg'">
            }
          </mat-cell>
        </ng-container>
        <!-- Name Column -->
        <ng-container cdkColumnDef="name">
          <mat-header-cell [ngClass]="'customWidthClass'" *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let user" [ngClass]="'customWidthClass'">
            <p class="text-truncate">{{user.firstName}} {{user.lastName}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="email">
          <mat-header-cell  class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.email' | translate}}</mat-header-cell>
          <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
            <p class="text-truncate">{{user.email}}</p>
          </mat-cell>
        </ng-container>


        <!-- Code Column -->
        <!--<ng-container cdkColumnDef="code">-->
        <!--<mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.code' | translate}}</mat-header-cell>-->
        <!--<mat-cell *cdkCellDef="let canton">-->
        <!--<p class="text-truncate">{{canton.code}}</p>-->
      <!--</mat-cell>-->
    <!--</ng-container>-->
    <ng-container cdkColumnDef="role">
      <mat-header-cell class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.role' | translate}}</mat-header-cell>
      <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
        @if (user.role) {
          <p class="text-truncate">{{user.role.name}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="country">
      <mat-header-cell class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.country' | translate}}</mat-header-cell>
      <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
        <img style="height: 40px" [src]="'assets/images/' + user.country.flag + '.svg'"/>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="canton">
      <mat-header-cell class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.canton' | translate}}</mat-header-cell>
      <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
        @if (user.city) {
          <p class="text-truncate">{{user.city.name}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="organization">
      <mat-header-cell class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.organization' | translate}}</mat-header-cell>
      <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
        @if (user.organization) {
          <p class="text-truncate">{{user.organization.name}}</p>
        }
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="lang">
      <mat-header-cell class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.lang' | translate}}</mat-header-cell>
      <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
        <p class="text-truncate">{{user.lang}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="activated">
      <mat-header-cell class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.activated' | translate}}</mat-header-cell>
      <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
        @if (user.activated) {
          <mat-icon class="active">check_circle_outline</mat-icon>
        }
        @if (!user.activated) {
          <mat-icon class="no_active">highlight_off</mat-icon>
        }
      </mat-cell>
    </ng-container>


    <ng-container cdkColumnDef="sendInvite">
      <mat-header-cell class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.sendInvite' | translate}}</mat-header-cell>
      <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
        @if (user.sendInvite) {
          <mat-icon class="active">contact_mail</mat-icon>
        }
        @if (!user.sendInvite) {
          <mat-icon class="no_active">contact_mail</mat-icon>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="blocked">
      <mat-header-cell class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.blocked' | translate}}</mat-header-cell>
      <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
        @if (user.blocked) {
          <img style="width: 24px" [src]="'assets/images/insecure.svg'">
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="impersonation">
      <mat-header-cell class="impersonation-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'user.impersonation' | translate}}</mat-header-cell>
      <mat-cell class="impersonation-on-mobile" *cdkCellDef="let user">
        @if (+userId !== +user.id) {
          <img (click)="logSuperUser($event, user.id)" style="width: 50px; cursor:pointer"
            [src]="'assets/images/login.svg'">
          }
        </mat-cell>
      </ng-container>

      <ng-container cdkColumnDef="mainAdmin">
        <mat-header-cell class="hide-on-mobile" *cdkHeaderCellDef mat-sort-header>{{'mainAdmin' | translate}}</mat-header-cell>
        <mat-cell class="hide-on-mobile" *cdkCellDef="let user">
          @if (user?.isMainAdmin) {
            <mat-icon style="color: green" class="main_admin">person</mat-icon>
          }
          </mat-cell>
      </ng-container>


      <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

      <mat-row *cdkRowDef="let user; columns: displayedColumns"
        class="product"
        matRipple
        (click)="navigateToUserDetail(user)">
      </mat-row>

    </mat-table>
    @if (users.length === 0) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{'main.noData' | translate}}</span>
      </div>
    }
    <mat-paginator #paginator
      [length]="pagination?.total"
      [pageIndex]="_pageIndex"
      [pageSize]="_perPage"
      [pageSizeOptions]="[25, 50, 100]"
      (page)="changePageEmitter($event)">
    </mat-paginator>

  </div>






    <!--<mat-sidenav-container class="my-sidenav"  style="  position: absolute;-->
    <!--width: 210px;-->
    <!--height: calc(100vh - 210px);-->
    <!--right: 0;-->
    <!--z-index: 999;-->
    <!--top: 136px;-->
   <!--background: white;">-->
      <!--<mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"-->
                   <!--fuseMatSidenavHelper="user-main-sidenav" mat-is-locked-open="gt-sm"-->
                   <!--[ngClass]="{'hide-menu': !sidenav.opened}" style="    position: absolute;-->
    <!--width: 100%;-->
    <!--margin: 0px;-->
    <!--display: flex;-->
    <!--flex: 1 1 0%;-->
    <!--flex-direction: column;-->
    <!--overflow: hidden;-->
    <!--transform: none;-->
    <!--visibility: visible;">-->
        <!--<filter-menu [filters]="filterData" [page]="'admin'" [filterFromDB]="userFilters"-->
                     <!--(chooseFilter)="chooseFilters($event)"></filter-menu>-->
      <!--</mat-sidenav>-->
    <!--</mat-sidenav-container>-->
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>





